import { render, staticRenderFns } from "./Halberd.vue?vue&type=template&id=77e60319&"
import script from "./Halberd.vue?vue&type=script&lang=js&"
export * from "./Halberd.vue?vue&type=script&lang=js&"
import style0 from "./Halberd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports